<template>
    <label class="position-relative" :class="{'checked': isChecked}" :for="id">
        <input class="form-check-input" :id="id" ref="checkbox" type="checkbox" v-model="model" :value="value" />

        <div class="card card-fly card-gradient h-100">
            <div class="icon mx-auto ms-sm-0" style="background: rgba(234, 134, 133, 0.3);">
                <i :class="iconClass" style="color: rgb(234, 134, 133);"></i>
            </div>

            <h3 class="h4 mb-1">
                {{ title }}
            </h3>
            <p class="mb-0 small d-none d-sm-block">
                <slot/>
            </p>
            <img loading="lazy" :src="image">

            <div class="position-absolute top-0 end-0 m-4">
                <span v-if="isChecked">JA</span>
                <span v-else>NEE</span>
            </div>
        </div>
    </label>
</template>

<script setup>
    import {computed, defineEmits} from "vue";

    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        modelValue: {
            type: [
                Array,
                Boolean
            ]
        },
        value: {
            type: [
                Boolean,
                Object
            ]
        },
        title: {
            type: String,
        },
        image: {
            type: String,
        },
        iconClass: {
            type: String,
            default: 'fad fa-lightbulb-on',
        }
    });

    const emit = defineEmits(["update:modelValue"]);

    const model = computed({
        get() {
            return props.modelValue;
        },
        set(value) {
            console.log(value);
            emit("update:modelValue", value);
        }
    });

    const isChecked = computed(() => {
        return props.modelValue.includes(props.value);
    })
</script>